export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.3-1151.15",
  commitId: "98443f117aa4604eeb4119ee95ef39d287eb3db0",
  commitTime: "2026-09-03T11:51:15.000Z",
});
